import type { StartAppListening } from '@/store/listenerMiddleware.ts';
import { optionSlice } from '@/store/option/slice.ts';
import { changeClient } from '@/store/tabs/slice.ts';
import { selectTileClientId } from '@/store/tiles/selectors.ts';

export const registerChangeClientListenerForOption = (startAppListening: StartAppListening) => {
  startAppListening({
    actionCreator: changeClient,
    effect: (action, api) => {
      const currentState = api.getState();
      const previousState = api.getOriginalState();

      for (const { tileId } of optionSlice.selectors.getAllOptionProducts(currentState)) {
        if (currentState.tiles.entities[tileId]?.tabId !== action.payload.tabId) {
          continue;
        }

        const previousClientId = selectTileClientId(previousState, tileId);
        const currentClientId = selectTileClientId(currentState, tileId);
        if (previousClientId === currentClientId) {
          continue;
        }

        api.dispatch(optionSlice.actions.optionClientIdUpdated({ tileId, clientId: currentClientId }));
      }
    },
  });
};
